module.exports = __webpack_public_path__ + "static/debt-consolidation-0f576f244e686002b681cb5dc8e3ad8e.png";